export default __webpack_public_path__ + "static/media/me_x2.7f395af9.jpg";